import { render, staticRenderFns } from "./FileTypeIcon.vue?vue&type=template&id=63cd9e96&"
import script from "./FileTypeIcon.vue?vue&type=script&lang=ts&"
export * from "./FileTypeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports